export function buildTrainingLocation({ miasto, ulica, kod_pocztowy, location } = {}) {
	const cityAndStreet = [miasto, ulica]
		.map(value => `${value || ''}`.trim())
		.filter(Boolean)
		.join(', ')

	if (cityAndStreet) return cityAndStreet

	return `${location || ''}`.trim()
}
